import { Companies } from '@clearkit/icons';
import { CKActionMenu, CKBadge, cloneChildren } from 'clearkit';
import { ReactNode } from 'react';

import { ProspectorListItem } from './types';

type MenuItemProps = {
  icon: ReactNode;
  item: ProspectorListItem;
};

export const MenuItem = ({ item, icon }: MenuItemProps) => {
  let countDisplay: string | number = '';

  if (item.count)
    countDisplay = item.count > 1000 ? `${item.count / 1000}K` : item.count;

  return (
    <CKActionMenu.Item
      className="group"
      key={item.title}
      leftIcon={
        <>
          {cloneChildren({
            children: icon,
            newProps: {
              className:
                'fill-gradient-br-blue group-hover:fill-white group-focus:fill-white',
            },
          })}
        </>
      }
      rightIcon={
        <CKBadge className="group-hover:bg-white group-focus:bg-white group-hover:text-blue-500 group-focus:text-blue-500">
          <Companies className="w-3 h-3 mr-1" />
          {countDisplay}
        </CKBadge>
      }
    >
      {item.title}
    </CKActionMenu.Item>
  );
};
